import { useEffect, useState } from "react";
import KriterSecenekleriservice from "../../../../service/Ebasvuru/KriterSecenekleriService";
import { Autocomplete, Box, duration, TextField } from "@mui/material";

const SelectionComponent = ({
    kriterId,
    kriterAdi,
    parentKriterId,
    parentSecenekId = null,
    selKriterler,
    bagliOlunanKriterId,
    bagliOlunanKriterSecenekId,
    zorunlu = false,
    onChange }) => {
    const [options, setOptions] = useState([]);

    const [visiable, setVisiable] = useState(true);

    useEffect(() => {


        if (bagliOlunanKriterId) {
            const isVisible =
                bagliOlunanKriterSecenekId &&
                selKriterler &&
                selKriterler[bagliOlunanKriterId]?.value === bagliOlunanKriterSecenekId;
            setVisiable(!!isVisible);

        } else {
            setVisiable(true);

        }


    }, [bagliOlunanKriterId, bagliOlunanKriterSecenekId, selKriterler]);

    useEffect(() => {

        if (kriterId && (parentKriterId === 0 || parentSecenekId || parentKriterId == null)) {
            KriterSecenekleriservice.fullGet({
                filter: {
                    kriterId,
                    parentKriterId: parentKriterId === 0 ? null : parentKriterId,
                    parentSecenekId,
                },
                order: [{ key: "siralama", value: "asc" }],
            }).then((res) => {
                if (res && res.isSuccess) {
                    setOptions(res.resultObject.map((item) => ({ text: item.secenekAdi, value: item.id })));
                }
            });
        } else {
            setOptions([]); // Reset options when parent selection changes
        }
    }, [kriterId, parentKriterId, parentSecenekId]);

    const getLabel = (text) => {
        if (zorunlu) {
            return `${text} *`;
        }
        return text;
    }

    if (visiable === false)
        return <></>

    return (
        <Box sx={{ pt: 2 }}>
            <Autocomplete
                key={kriterId}
                options={options}
                getOptionLabel={(option) => option.text}
                isOptionEqualToValue={(option, value) => option.value === value?.value}
                value={options.find((opt) => opt.value === (selKriterler[kriterId]?.value || null)) || null} // Ensure valid lookup
                renderInput={(params) => <TextField {...params}
                    label={
                        <span>
                            {kriterAdi}
                            {zorunlu && <span style={{ color: "red", fontSize: "1.3rem", fontWeight: "bold" }}> *</span>}
                        </span>
                    } variant="outlined" margin="dense" />}
                onChange={(_, value) => onChange(kriterId, value?.value || "", value?.text || "")}
                fullWidth
            />
        </Box>

    );
};

export default SelectionComponent;